'use client'

import { useState } from 'react'
import { Share2, Check } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ShareButtonProps {
  url?: string
  title?: string
  text?: string
  className?: string
}

export function ShareButton({ url, title, text, className }: ShareButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleShare = async () => {
    const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '')
    const shareTitle = title || document.title
    const shareText = text || shareTitle

    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl,
        })
      } catch (error) {
        if ((error as Error).name !== 'AbortError') {
          await copyToClipboard(shareUrl)
        }
      }
    } else {
      await copyToClipboard(shareUrl)
    }
  }

  const copyToClipboard = async (textToCopy: string) => {
    try {
      await navigator.clipboard.writeText(textToCopy)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Failed to copy:', error)
    }
  }

  return (
    <Button
      onClick={handleShare}
      variant="link"
      size="sm"
      className={className + ' flex flex-row gap-1 justify-center items-center'}
    >
      {copied ? (
        <>
          <Check className="mr-2 h-4 w-4" />
          Kopiert!
        </>
      ) : (
        <>
          <Share2 className="mr-2 h-4 w-4" />
          Teilen
        </>
      )}
    </Button>
  )
}
